var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "star_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 14.392 3.458 2.091a.831.831 0 0 0 1.242-.9l-.917-3.933L16.842 9c.558-.483.258-1.4-.475-1.458L12.342 7.2l-1.575-3.717c-.284-.675-1.25-.675-1.534 0L7.658 7.192l-4.025.341c-.733.059-1.033.975-.475 1.459l3.059 2.65-.917 3.933a.831.831 0 0 0 1.242.9L10 14.392Z",
    fill: "currentColor"
  })));
};
export { SvgStar as ReactComponent };